module.exports = __webpack_public_path__ + "static/media/SarahSwitek_10_Questions_2.4afe4196.mp3";